import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { CiiBadgeComponent } from '../../components/cii-badge/cii-badge.component';

@Component({
  selector: 'app-tma',
  standalone: true,
  imports: [RouterLink, CiiBadgeComponent],
  templateUrl: './tma.component.html',
  styleUrl: './tma.component.css'
})
export class TmaComponent implements OnInit {

  constructor(
    private titleService: Title, 
    private metaService: Meta
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Tierce Maintenance Applicative (TMA) Node.js & Angular — Expert MCO Agréé CII");
    this.metaService.updateTag({ name: 'description', content: "Externalisez la maintenance de vos applications critiques avec notre TMA Node.js & Angular. MCO, sécurité, performance et SLA garantis. Éligible Crédit Impôt Innovation." });
  }
}